import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSuggestionFreestyleTool,
  BackendQueryCustomerSuggestionFreestyleToolsArgs,
} from 'src/types/backend';

import { FRAGMENT_FREESTYLE_TOOL } from './schema';

const QUERY = gql`
  query QueryCustomerSuggestionFreestyleTools($customerId: ID!, $workspaceId: ID) {
    customerSuggestionFreestyleTools(customerId: $customerId, workspaceId: $workspaceId) {
      ...SuggestionFreestyleTool
    }
  }
  ${FRAGMENT_FREESTYLE_TOOL}
`;

type Variables = BackendQueryCustomerSuggestionFreestyleToolsArgs;
type Result = BackendCustomerSuggestionFreestyleTool[];

export const querySuggestionFreestyleTools = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  const tools = getSingleProp<Result>(result.data) ?? [];
  return tools.map((tool) => ({
    ...tool,
    allInstructionsData: tool.allInstructionsData
      ? JSON.parse(tool.allInstructionsData as string)
      : null,
  }));
};
